import Authenticator from 'components/economic-concret/authenticator';
import {useState} from 'react';
import {Button, Card, Col, Form, Row} from 'react-bootstrap';
import Loading from 'components/economic-concret/components/loading';
import ErrorMessage from 'components/economic-concret/components/errorMessage';
import SuccessMessage from '../components/successMessage';
import api from 'components/economic-concret/api/api';

export default function ChangePasswordFromUser() {

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    const handleChangePassword = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const dataToSend = {
            login: sessionStorage.getItem('userEmail'),
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmNewPassword: confirmNewPassword
        };

        api.patch('/users/change-password', dataToSend, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        })
            .then((response) => {
                setSuccessMessage(response.data);
                setShowSuccessMessage(true);
            })
            .catch((error) => {
                const errorMessage = error.response?.data ?? "Erro de comunicação com o servidor.";
                setErrorMessage(errorMessage);
                setShowErrorMessage(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Card className="bg-transparent-50 overflow-hidden" style={{ minHeight: '250px' }}>
            <Authenticator />
            <Card.Header className="position-relative">
                <div className="row flex-between-center">
                    <div className="col col-lg-8">
                        <h5 className="mb-0 texto-negrito">
                            Alterar Senha
                        </h5>
                    </div>
                </div>
            </Card.Header>

            <Card.Body>
                {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
                {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}

                <Loading isToHidden={!isLoading} />

                <Form onSubmit={handleChangePassword} hidden={isLoading}>
                    <Row>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="current">
                                <Form.Label className="fs-9">Senha Atual</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="newPassword">
                                <Form.Label className="fs-9">Nova Senha</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="confirmNewPassword">
                                <Form.Label className="fs-9">Confirmar Nova Senha</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={confirmNewPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end">
                        <Button type="submit" disabled={isLoading}>
                            {isLoading ? 'Alterando...' : 'Alterar Senha'}
                        </Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
}
